import React from "react";
import "./AboutSection.css";

const AboutSection = () => {
  return (
    <section className="about-section" id="div_1dd7_31">
      <div className="about-container">
        {/* Left Column: Logo */}
        <div className="about-left">
          <img
            src={`${process.env.PUBLIC_URL}/images/louis-logo.png`}
            alt="IIHS Logo"
            className="about-logo"
          />
        </div>

        {/* Right Column: Text Content */}
        <div className="about-right">
          <h3 className="about-title">About Us</h3>
          <p className="about-quote">
            <b>"From His Fullness we have all received grace upon grace" (John 1:16)</b>
          </p>
          <p className="about-text">
            Six years for an institution is a worthy stage where one can start
            matching expectations with results, objectives with achievements.
            Above all, blessings enjoyed with difficulties and hardships endured! 
            It’s a day of retrospection! Immaculate institute of health sciences, 
            just five years young, a promising institution of the region providing 
            value added, quality education in nursing, an institution striving 
            towards excellence! <b>"The true work of art is but a shadow of the divine Perfection"</b> 
            So do we, at IIHS with the vision <b>"Life in fullness"</b> several steps 
            are being undertaken for multi dimensional growth of the institution 
            and contributing in turn, towards the growth of a healthy and happy society.
          </p>
          <a href="/about" className="about-button">
            Read More <i className="fa fa-long-arrow-right"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
